import { Button, Modal, Row, Col } from 'antd'; 
import { formatWithCommas } from "../../utils/utils"; 

const SoaDetailsModal = (props) => {
    const {
        selectedEditActivity,
        endpointsSelector,
        handleCancelEditActivity,
        editActivityModal,
        handleOkEditActivity
    } = props;
    return ( 
        <Modal 
        visible={editActivityModal} className="endpoint-soa-modal" title="" closable={false} mask={false} onCancel={handleCancelEditActivity} footer={null} style={{ left: '12%', top:10 }} centered={false} maskClosable={false}
        wrapClassName="soaDetailModal">
        <Row className="soa-configure-title">
          <Col span={18}>
            <span>Details</span>
          </Col>
          <Col span={6}>
          <Button className="cancel-btn" onClick={handleCancelEditActivity}> Cancel</Button>
          <Button className="create-btn" onClick={(e) => handleOkEditActivity(e, selectedEditActivity)}>Submit</Button>
          </Col> 
        </Row>
        
        <br/>
        <Row className="endpoint-modal-filed">
          <Col span={24} className="informed-consent-label"><span>{selectedEditActivity['Standard Activity']}</span></Col>
          <Col span={24} className="procedure-label"><span>{selectedEditActivity['Categories']}</span></Col>
          <Col span={24}><span><br /></span></Col>
          
          <Col span={8} className="label-header"><span>Activity frequency </span></Col>
          <Col span={8} className="label-header"><span>Visit frequency</span></Col>
          <Col span={8} className="label-header"><span>Cost per patient</span></Col>
          <Col span={8} className="label-values"> { selectedEditActivity.Frequency==="NA"?"NA" :  Math.round(selectedEditActivity.Frequency * 10000) / 100 + "%"}</Col>
          <Col span={8} className="label-values"><span>{selectedEditActivity['visit_frequency'] ==="NA"?"NA" : Math.round(selectedEditActivity['visit_frequency'] * 100) / 100 + "%"}</span></Col>
          <Col span={8} className="label-values"><span>{selectedEditActivity && selectedEditActivity?.cost !== "" && selectedEditActivity?.cost !== null ? `$ ${formatWithCommas(selectedEditActivity.cost)}` : ''}</span></Col>  


          <Col span={24} ><span><br /></span></Col>
           
        </Row>
        <br />
        <Row className="soa-endpoint-selector">
          <Col span={24}>
          <div>Select trial endpoint</div>
          {endpointsSelector(selectedEditActivity, 1)}
          </Col>
        </Row>
        
       
      </Modal>)
}

export default SoaDetailsModal;